import { Component, OnInit, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { SharedService } from '../../../../../shared/shared.service';
import { DriversService } from '../../drivers.service';
import { DxDataGridComponent } from 'devextreme-angular';



@Component({
  selector: 'app-driver',
  templateUrl: './driver.component.html',
  styleUrls: ['./driver.component.css']
})
export class DriverComponent implements OnInit {
  dataSource;
  sessionId = sessionStorage.getItem('com-session-id');

  constructor(
    public sharedService: SharedService,
    public drivers: DriversService,
    private httpClient: HttpClient
  ) { }

  ngOnInit() {
    this.sharedService.loadingActive = true;
    // tslint:disable-next-line:max-line-length
    this.httpClient.get<any>(`${this.sharedService.URL}/dbDriver?SessionID=${this.sessionId}&Search=*&IncludePhoto=1`).subscribe(Response => {
      this.dataSource = Response.dbDriver_response.view;
      this.sharedService.loadingActive = false;
    });
    this.sharedService.loadingActive = false;
  }

  clickEdit(data) {
    this.drivers.setNewEdit(0);
    sessionStorage.setItem('driver-id', data);
  }

  clickNew() {
    this.drivers.setNewEdit(1);
  }

}
